import { TreeItem, TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { CollectionRootTreeItem } from '../components/CollectionRootTreeItem.js'
import { SimpleTreeItemData } from '../types.js'

export const COLLECTIONS_INDEX = 'collections'

export function createCollectionsRootTreeItem(
  { $t }: I18nShape,
  {
    children,
  }: {
    children: TreeItemIndex[]
  },
): TreeItem<SimpleTreeItemData> {
  return {
    index: COLLECTIONS_INDEX,
    isFolder: true,
    data: {
      title: $t({
        id: 'Generics.Collections',
        defaultMessage: '{COLLECTIONS_CC}',
      }) as string,
      type: 'simple',
      render: CollectionRootTreeItem,
    },
    children,
  }
}
